import React, { useState, useReducer, createContext, useContext, useEffect, useRef } from 'react';
import { Select, Button, Table, Modal, Input, DatePicker, Switch, message, Cascader, Alert, Spin, Radio, Upload } from 'antd';
import "./index.less";
import { designerClassifyList, designUpOrDown, desingerQueryList, queryCaseDesignMaster, updateDesignMaster, addCaseDesignMaster, dealRelInfo, queryCaseInfo, deleteCaseImg, news_host, addBatch } from "../../api";
// import AliUploader from '../../component/AliUploader/linggan_aliupload'
// import AliUploader1 from '../../component/AliUploader/linggan_aliupload'
import { UploadToOss } from '../../util/uploadTool';
import { lowerFirst, set } from 'lodash';
const { Option } = Select;
const { TextArea } = Input;
const { RangePicker } = DatePicker;
const Ctx = createContext();
const reg = /^\d+(\.\d+)?$/;
const commonHeaderImg = 'https://dingzi-jsfile.oss-cn-shanghai.aliyuncs.com/lb_img_space/commonHeaderImg.png'
const initInfo = {
    headTitle: '',
    classifyList: [],
    styleList: [],
    propertyList: [],
    isEditor: false,
    styleId: null,
    propertyId: null,
    caseClassifyDTOList: {},
    designMaster: null,
    id: null
}
const reducer = (state, action) => {
    return { ...state, ...action };
}
const statusData = [
    {
        id: 2,
        name: '全部'
    },
    {
        id: 0,
        name: '上架'
    },
    {
        id: 1,
        name: '下架'
    },
]
const caseLevel = [
    {
        id: 1,
        levelName: '一级',
    },
    {
        id: 2,
        levelName: '二级',
    },
    {
        id: 3,
        levelName: '三级',
    }
]
const num = 10
const url = 'https://image.znzgo.com/cover/fc6a3dc71a344cfeb96a909a1be269c6.jpg?x-oss-process=image/auto-orient,1/resize,m_fill,w_748,h_566,limit_0/quality,q_100/format,webp'


//  子组件模态框
const EditModal = () => {
    const { state: { isModalVisible, info }, dispatch } = useContext(Ctx);
    const [desingerName, setDesingerName] = useState('');//设计师名称填写
    const [desingerSort, setDesingerSort] = useState(null);//设计师序号填写
    const [firstClassifyChoose, setfirstClassifyChoose] = useState(null);//一级分类默认选中
    const [secondClassifyChoose, setsecondClassifyChoose] = useState(null); // 二级分类默认选中
    const [thirdClassifyChoose, setThirdClassifyChoose] = useState(null); // 二级分类默认选中
    const [firstClassifyList, setFirstClassifyList] = useState([]);
    const [secondClassifyList, setSecondClassifyList] = useState([]);
    const [thirdClassifyList, setThirdClassifyList] = useState([]);
    const [styleList, setStyleList] = useState(info.styleList);// 设计师风格下拉框数据
    const [propertyList, setPropertyList] = useState(info.propertyList);//擅长领域下拉框数据
    const [styleChoose, setStyleChoose] = useState(null); // 风格选中
    const [propertyId, setPropertyId] = useState(null); // 擅长领域选中

    const [headerImg, setHeaderImg] = useState(''); // 头像图图片地址
    const [backImg, setBackImg] = useState(''); // 背景图图片地址
    const [desingerIntroduce, setDesingerIntroduce] = useState(''); // 背景图图片地址
    const [firstClassifyChangeBol, setFirstClassifyChangeBol] = useState(false);//一级分类手动改变时为 true
    const [secondClassifyChangeBol, setSecondClassifyChangeBol] = useState(false);//一级分类手动改变时为 true

    const [ossData, setOssData] = useState()
    const [ossData1, setOssData1] = useState()
    const uploaderInit0 = useRef({})
    const uploaderInit1 = useRef({})
    const dirname = 'caseManage/'
    const imgPrefix =
        'https://qingtu-image-originals.oss-cn-shanghai.aliyuncs.com'
    const token = {
        host: 'https://image.znzgo.com/',
        ALI_HOST: imgPrefix,
        // access_key_id: 'LTAI5t8ubGymdJDnqyAe2EM2', // oss的key_id
        // access_key_secret: 'zfkvIN3eft7FrYJqfCRDURjGxhSHcF', // oss的secret
        OSS_ENDPOINT: 'oss-cn-shanghai.aliyuncs.com', // 自己oss服务器的配置信息
        OSS_BUCKET: 'qingtu-image-originals', // 自己oss服务器的配置信息
        OSS_REGION: 'oss-cn-shanghai',
    }

    useEffect(() => {

        if (!isModalVisible) {
            setFirstClassifyChangeBol(false)
            setSecondClassifyChangeBol(false)
        }
    }, [isModalVisible])
    useEffect(() => {
        if (info.designMaster) {
            if (info?.caseClassifyDTOList?.parentId == 0) {
                setfirstClassifyChoose(info?.caseClassifyDTOList.id)
            } else {
                setfirstClassifyChoose(info?.caseClassifyDTOList.rootId)
            }
            setDesingerName(info?.designMaster?.name)
            setStyleChoose(info.styleId)
            setPropertyId(info.propertyId)
            setHeaderImg(info?.designMaster.cover)
            setBackImg(info?.designMaster.background)
            setDesingerIntroduce(info?.designMaster.introduce)
        }
        if (info.classifyList.length > 0) {
            setFirstClassifyList(info.classifyList)
        }
        if (info.styleList.length > 0) {
            setStyleList(info.styleList)
        }
        if (info.propertyList.length > 0) {
            setPropertyList(info.propertyList)
        }
        if (!info.isEditor) {
            setDesingerSort(null)
            setDesingerName('')
            setHeaderImg('')
            setBackImg('')
            setDesingerIntroduce('')
            setfirstClassifyChoose('')
            setStyleChoose('')
            setPropertyId(null)
        }
    }, [info])
    useEffect(() => {
        if (firstClassifyChoose == '') {
            setSecondClassifyList([])
            setThirdClassifyList([])
        } else {
            let secondClassifyList = firstClassifyList.filter(item => item.id == firstClassifyChoose)
            console.log(secondClassifyList)
            if (secondClassifyList.length > 0) {
                setSecondClassifyList(secondClassifyList[0].secondClassifies)//存储当前二级分类数据
                if (secondClassifyList[0].secondClassifies.length > 0) {
                    if (firstClassifyChangeBol) {
                        setsecondClassifyChoose(secondClassifyList[0].secondClassifies[0].id)
                    } else {
                        if (info.designMaster) {
                            setsecondClassifyChoose(info?.caseClassifyDTOList.parentId)
                        } else {
                            setsecondClassifyChoose(secondClassifyList[0].secondClassifies[0].id)
                        }
                    }
                } else {
                    setsecondClassifyChoose('')
                    setThirdClassifyChoose('')
                }
            }

        }
    }, [firstClassifyChoose, info, firstClassifyChangeBol])
    useEffect(() => {
        if (secondClassifyChoose == '') {
            // setThirdClassifyList([])
        } else {
            let thirdClassifyListArr = secondClassifyList.filter(item => item.id == secondClassifyChoose)
            if (thirdClassifyListArr.length > 0) {
                setThirdClassifyList(thirdClassifyListArr[0].thirdClassifies)
                if (thirdClassifyList.length > 0) {
                    console.log(thirdClassifyList)
                    if (firstClassifyChangeBol || secondClassifyChangeBol) {
                        setThirdClassifyChoose(thirdClassifyListArr[0].thirdClassifies[0].id)
                    } else {
                        if (info.designMaster) {
                            setThirdClassifyChoose(info?.caseClassifyDTOList.id)
                        } else {
                            setThirdClassifyChoose(thirdClassifyListArr[0].thirdClassifies[0].id)
                        }
                    }
                } else {
                    setThirdClassifyChoose('')
                }
            }
        }
    }, [secondClassifyChoose, info, thirdClassifyList, firstClassifyChangeBol, secondClassifyChangeBol])
    // 最终提交
    const confirm = async (isEditor) => {
        console.log("isEditor", isEditor)
        let res;
        // 点击确认修改按钮
        if (!isEditor) {
            if (!desingerSort) {
                message.error('请输入序号');
                return;
            }
        }
        if (desingerName == '' && desingerName.trim() == '') {
            message.error('请输入设计师名称');
            return;
        }
        if (headerImg == '') {
            message.error('请上传头像');
            return;
        }
        // if (backImg == '') {
        //     message.error('请上传背景图片');
        //     return;
        // }
        if (desingerIntroduce == '') {
            message.error('请输入设计师描述');
            return;
        }
        if (!firstClassifyChoose) {
            message.error('请选择分类');
            return;
        }
        if (!styleChoose) {
            message.error('请选择设计风格');
            return;
        }
        if (propertyId == null) {
            message.error('请选择擅长领域');
            return;
        }
        let params = {
            background: backImg,
            classifyId: thirdClassifyChoose ? thirdClassifyChoose : (secondClassifyChoose ? secondClassifyChoose : firstClassifyChoose),
            cover: headerImg,
            id: info.id,
            introduce: desingerIntroduce,
            name: desingerName,
            propertyId: propertyId,
            sort: desingerSort,
            styleId: styleChoose,
        }
        //  true为编辑
        if (isEditor) {
            params.designPropertyId = info.designMaster.propertyId
            res = await updateDesignMaster(params);
        } else {
            // false为新建
            params.id = null

            res = await addCaseDesignMaster(params);

        }
        //调确认修改接口
        if (res?.error?.errorCode == 0) {
            if (isEditor) {
                message.success('修改成功')
            } else {
                message.success('新建成功')
            }
            setDesingerSort(null)
            setDesingerName('')
            setHeaderImg('')
            setBackImg('')
            setDesingerIntroduce('')
            setfirstClassifyChoose('')
            setsecondClassifyChoose('')
            setThirdClassifyChoose('')
            setStyleChoose('')
            setPropertyId(null)
            dispatch({ isModalVisible: false, success: true });//关闭弹窗刷新列表
        } else {
            message.error(res?.error?.errorMsg)
        }


    }
    const handleCancel = () => {
        dispatch({ isModalVisible: false });
        setDesingerSort(null)
        setDesingerName('')
        setHeaderImg('')
        setBackImg('')
        setDesingerIntroduce('')
        setfirstClassifyChoose('')
        setsecondClassifyChoose('')
        setThirdClassifyChoose('')
        setStyleChoose('')
        setPropertyId(null)
    };

    // 描述change、
    const handleDesingerIntroduce = (e) => {
        setDesingerIntroduce(e.target.value)
    }
    // 一级分类change
    const handleChangeFirstClassify = value => {
        setsecondClassifyChoose('')
        setThirdClassifyChoose('')
        setfirstClassifyChoose(value);
        setFirstClassifyChangeBol(true)
        let secondClassifyList = firstClassifyList.filter(item => item.id == value)
        setSecondClassifyList(secondClassifyList[0].secondClassifies)//存储当前二级分类数据
        if (secondClassifyList[0].secondClassifies.length > 0) {
            setsecondClassifyChoose(secondClassifyList[0].secondClassifies[0].id)
        } else {
            setsecondClassifyChoose('')
            setThirdClassifyChoose('')
        }
    };
    // 二级分类change
    const handleChangeSecondClassify = value => {
        setsecondClassifyChoose(value);
        setSecondClassifyChangeBol(true)
        let thirdClassifyList = secondClassifyList.filter(item => item.id == value)
        setThirdClassifyList(thirdClassifyList[0].thirdClassifies)
        if (thirdClassifyList[0].thirdClassifies.length > 0) {
            setThirdClassifyChoose(thirdClassifyList[0].thirdClassifies[0].id)
        } else {
            setThirdClassifyChoose('')
        }
    };
    // 三级分类change
    const handleChangeThirdClassify = value => {
        setThirdClassifyChoose(value);
    };

    //  风格选中 
    const handleChangeStyle = value => {
        setStyleChoose(value)
    }
    //  擅长领域选中 
    const handleChangeField = value => {
        setPropertyId(value)
    }

    const beforeUpload = (file, type) => {
        const img_type = ['image/png', 'image/jpeg', 'image/jpg', 'image/gif'];
        const img_size = file.size / 1024 / 1024;
        if (!img_type.includes(file.type)) {
            return false;
        }
        if (img_size > 50) {
            return false;
        }

        let reader = new FileReader();
        reader.readAsDataURL(file);
        const OssToken = token;
        reader.onloadend = async () => {
            // 使用ossupload覆盖默认的上传方法
            message.loading('上传中');
            UploadToOss({ token: OssToken }, OssToken.ALI_HOST, file)
                .then((data) => {
                    let sourceLink = OssToken.host + '/' + data.name;
                    if (type == 'bg') {
                        setBackImg(sourceLink)
                    } else {
                        setHeaderImg(sourceLink)
                    }

                    console.debug('data', data)
                    message.success('上传成功！')
                })
                .catch((err) => {
                    message.destroy();
                    message.error('上传失败，请重试~');
                })
                .finally(() => {
                    message.destroy();
                });
        };

        return false;
    };
    return (
        <div>
            <Modal width='1000px' visible={isModalVisible} forceRender wrapClassName='classify_modal' onCancel={handleCancel} title={info.headTitle} footer={[
                <Button key="submit" type="primary" onClick={() => handleCancel()}>
                    取消
                </Button>, <Button key="submit" type="primary" onClick={() => confirm(info.isEditor)}>
                    确认
                </Button>
            ]}>
                {
                    <div className='content'>
                        <div className='topFlex'>
                            <div className='leftInput'>
                                <div className='form_item title'>
                                    <span className='form_label'>序号&nbsp;&nbsp;：</span>
                                    {
                                        !info.isEditor ? (<Input className='form_item_input' placeholder="请输入序号" style={{ width: 100 }} value={desingerSort} onChange={e => setDesingerSort(e.target.value.replace(/[^\-?\d.]/g, ''))} />) : <span>{info.designMaster.sort}</span>
                                    }
                                </div>
                                <div className='form_item title'>
                                    <span className='form_label'>设计师名称&nbsp;&nbsp;：</span>
                                    <Input className='form_item_input' placeholder="请输入设计师名称" maxLength={20} style={{ width: 200 }} value={desingerName} onChange={e => setDesingerName(e.target.value)} />
                                </div>
                            </div>

                            <div className='rightHeaderImg'>
                                <div className='label'>
                                    <span>头像：</span>
                                    <span>(请上传正方形图片)</span>
                                </div>
                                <Upload
                                    // {...props}
                                    showUploadList={false}
                                    beforeUpload={(file) => beforeUpload(file, 'header')}
                                >
                                    <div className='rightImg' id='upload_img_0'>
                                        <img className='uploadIcon' src="https://dingzi-jsfile.oss-cn-shanghai.aliyuncs.com/lb_img_space/uploadIcon.png" alt="" />
                                        {
                                            headerImg ? (
                                                <img className='headerImg' src={headerImg} alt="" />
                                            ) : ''
                                        }
                                    </div>
                                </Upload>

                            </div>
                        </div>
                        <div className='middleInput'>
                            <div className='form_item title'>
                                <span className='form_label'>背景图：</span>
                                <Upload
                                    // {...props}
                                    showUploadList={false}
                                    beforeUpload={(file) => beforeUpload(file, 'bg')}
                                >
                                    <div className='backImg' id='upload_img_1'>
                                        <img className='uploadIcon' src="https://dingzi-jsfile.oss-cn-shanghai.aliyuncs.com/lb_img_space/uploadIcon.png" alt="" />
                                        {
                                            backImg ? (
                                                <img className='backImg' src={backImg} alt="" />
                                            ) : ''
                                        }
                                    </div>
                                </Upload>

                            </div>
                            <div className='form_item title'>
                                <span className='form_label'>描述：</span>
                                <TextArea value={desingerIntroduce} rows={4} onChange={handleDesingerIntroduce} maxLength={1000} style={{ width: 360, height: 130 }} />
                            </div>
                            <div className='form_item title'>
                                <span className='form_label'>一级分类：</span>
                                <Select value={firstClassifyChoose} style={{ width: 280 }} onChange={handleChangeFirstClassify}>
                                    {
                                        firstClassifyList.length > 0 ? firstClassifyList.map((item, index) => {
                                            return (
                                                <Option value={item.id} key={index}>{item.name}</Option>
                                            )
                                        }) : ''
                                    }
                                </Select>
                            </div>
                            <div className='form_item title'>
                                <span className='form_label'>二级分类：</span>
                                <Select value={secondClassifyChoose} style={{ width: 280 }} onChange={handleChangeSecondClassify}>
                                    {
                                        secondClassifyList.length > 0 ? secondClassifyList.map((item, index) => {
                                            return (
                                                <Option value={item.id} key={index}>{item.name}</Option>
                                            )
                                        }) : ''
                                    }
                                </Select>
                            </div>
                            <div className='form_item title'>
                                <span className='form_label'>三级分类：</span>
                                <Select value={thirdClassifyChoose} style={{ width: 280 }} onChange={handleChangeThirdClassify}>
                                    {
                                        thirdClassifyList.length > 0 ? thirdClassifyList.map((item, index) => {
                                            return (
                                                <Option value={item.id} key={index}>{item.name}</Option>
                                            )
                                        }) : ''
                                    }
                                </Select>
                            </div>

                            <div className='form_item title'>
                                <span className="form_label">设计风格：</span>
                                <Select value={styleChoose} style={{ width: 280 }} onChange={handleChangeStyle}>
                                    {
                                        styleList.length > 0 ? styleList.map((item, index) => {
                                            return (
                                                <Option value={item.id} key={index}>{item.styleValue}</Option>
                                            )
                                        }) : ''
                                    }
                                </Select>
                            </div>
                            <div className='form_item title'>
                                <span className="form_label">擅长领域：</span>
                                <Select value={propertyId} style={{ width: 280 }} onChange={handleChangeField}>
                                    {
                                        propertyList.length > 0 ? propertyList.map((item, index) => {
                                            return (
                                                <Option value={item.id} key={index}>{item.name}</Option>
                                            )
                                        }) : ''
                                    }
                                </Select>
                            </div>

                        </div>
                    </div>

                }
            </Modal>
            {/* <AliUploader
                id='upload_img_0'
                dirname={dirname}
                fileUploaded={(up, file, info, uploaded_object_name) => {
                    setHeaderImg(`${imgPrefix}/${uploaded_object_name}`)
                }}
                uploaderInit={(func) => (uploaderInit0.current = func)}
                token={token}
            />
            <AliUploader1
                id='upload_img_1'
                dirname={dirname}
                fileUploaded={(up, file, info, uploaded_object_name) => {
                    setBackImg(`${imgPrefix}/${uploaded_object_name}`)
                }}
                uploaderInit={(func) => (uploaderInit1.current = func)}
                token={token}
            /> */}

        </div>
    )
}
// 父组件 最外层
function ClassifyManage() {

    const [desingerName, setDesingerName] = useState('');//设计师名称填写
    const [desingerSort, setDesingerSort] = useState(null);//设计师序号填写

    const [firstClassifyChoose, setfirstClassifyChoose] = useState('');//一级分类默认选中
    const [secondClassifyChoose, setsecondClassifyChoose] = useState(''); // 二级分类默认选中
    const [thirdClassifyChoose, setThirdClassifyChoose] = useState(''); // 二级分类默认选中

    const [dateArr, setDateArr] = useState([]);//创建时间区间
    const [styleChoose, setStyleChoose] = useState(''); // 风格选中
    const [propertyId, setPropertyId] = useState(''); // 擅长领域选中

    const [listLoading, setListLoading] = useState(false)
    const [showSpinLoading, setShowSpinLoading] = useState(false)
    const [showImportModal, setShowImportModal] = useState(false)
    const [showAddWorkModal, setShowAddWorkModal] = useState(false)
    const [desingerAddName, setDesingerAddName] = useState('')
    const [chooseRadioValue, setChooseRadioValue] = useState(1)
    const [publicNumId, setPublicNumId] = useState('')
    const [caseLink, setCaseLink] = useState('')
    const [caseIds, setCaseIds] = useState('')
    const [uplodaData, setUplodaData] = useState()
    const [desingerId, setDesingerId] = useState()
    const [choosestatus, setChoosestatus] = useState(2)


    const [firstClassifyList, setFirstClassifyList] = useState([]);
    const [secondClassifyList, setSecondClassifyList] = useState([]);
    const [thirdClassifyList, setThirdClassifyList] = useState([]);
    const [styleList, setStyleList] = useState([]);// 设计师风格下拉框数据
    const [propertyList, setPropertyList] = useState([]);//擅长领域下拉框数据

    const [timer, setTimer] = useState(null);//发布时间
    const [tableList, setTableList] = useState([]);
    const [page, setPage] = useState(1)
    const [pageSize, setPageSize] = useState(9)
    const [total, setTotal] = useState(0)
    const [state, dispatch] = useReducer(reducer, {
        isModalVisible: false, info: initInfo, success: false
    });

    useEffect(() => {
        // 获取一级分类数据以及风格，擅长领域数据
        getFirstClassifyList()
    }, [])
    useEffect(() => {
        if (state.success) {
            getDataList(page);
            dispatch({ success: false })
        }
    }, [state.success]);

    useEffect(() => {
        if (firstClassifyChoose == '') {
            setSecondClassifyList([])
            setThirdClassifyList([])
        }
    }, [firstClassifyChoose])
    useEffect(() => {
        if (secondClassifyChoose == '') {
            setThirdClassifyList([])
        } else {
            let thirdClassifyList = secondClassifyList.filter(item => item.id == secondClassifyChoose)
            setThirdClassifyList(thirdClassifyList[0].thirdClassifies)
            if (thirdClassifyList[0].thirdClassifies.length > 0) {
                setThirdClassifyChoose(thirdClassifyList[0].thirdClassifies[0].id)
            }
        }
    }, [secondClassifyChoose])
    const columns = [
        {
            title: "序号",
            dataIndex: 'sort',
            width: '8%'
        },
        {
            title: '设计师名称',
            dataIndex: 'name',
            width: '8%',
        },
        {
            title: '分类',
            width: '12%',
            render: (r, q) => {
                return (
                    <span>
                        {(r.firstName ? r.firstName + '-' : '') + (r.secondName ? r.secondName + '-' : '') + (r.thirdName ? r.thirdName : '')}
                    </span>
                )
            }
        },
        {
            title: '设计风格',
            dataIndex: 'styleName',
            width: '12%',
        },
        {
            title: '擅长领域',
            dataIndex: 'propertyName',
            width: '12%',
        },
        {
            title: '创建时间',
            dataIndex: 'createTime',
            width: '12%',
        },
        {
            title: '操作',
            dataIndex: '',
            width: '14%',
            render: (v, r) => {
                return (
                    <>
                        <Button disabled={showSpinLoading} onClick={() => modify(r)} type='primary'>编辑</Button>
                        <Button disabled={showSpinLoading} onClick={() => downDesinger(r)} type={r.delStatus == 0 ? 'primary' : 'normal'} style={{ 'margin-left': '10px' }}>{r.delStatus == 0 ? '下架' : '上架'}</Button>
                        <Button disabled={showSpinLoading} style={{ 'margin-left': '10px' }} onClick={() => addWorks(r)} type='primary'>添加作品</Button>
                    </>
                )
            },
        }
    ]
    // 编辑带入当前列表的数据填充
    const modify = (record) => {
        queryCaseDesignMaster(record.id).then(res => {
            if (res?.error.errorCode == 0) {
                console.log(res?.data)
                dispatch({
                    isModalVisible: true,
                    info: {
                        ...state.info,
                        isEditor: true,
                        headTitle: '编辑设计师信息',
                        caseClassifyDTOList: res?.data?.caseClassifyDTOList[0],
                        designMaster: res?.data?.designMaster,
                        propertyId: res?.data?.propertyId,
                        styleId: res?.data?.styleId,
                        id: record.id
                    }
                });
            }
        })

    }
    //  下架当前案例
    const downDesinger = (record) => {
        designUpOrDown(record.id, record.delStatus == 0 ? 1 : 0).then((res) => {
            if (res?.error?.errorCode == 0) {
                if (record.id, record.delStatus == 0) {
                    message.info('下架成功')
                } else {
                    message.info('上架成功')
                }
                getDataList(1);//下架成功刷新列表
                setPage(1)
            }
        })
    }
    // 添加作品按钮点击
    const addWorks = (record) => {
        console.log(record)
        setDesingerAddName(record.name)
        setShowAddWorkModal(true)
        setDesingerId(record.propertyId)
    }
    // 获取案例列表 渲染表格
    const getDataList = (page) => {
        setListLoading(true)
        let reviewRequest = {
            name: desingerName,
            startTime: dateArr[0] ? dateArr[0] : '',
            endTime: dateArr[1] ? dateArr[1] : '',
            page: page,
            propertyId: propertyId,
            pageSize: pageSize,
            firstClassifyId: firstClassifyChoose,
            secondClassifyId: secondClassifyChoose,
            thirdClassifyId: thirdClassifyChoose,
            sort: desingerSort,
            styleId: styleChoose,
            delStatus: choosestatus == 2 ? null : choosestatus
        }

        getClassiftListMethod(reviewRequest)
    }
    // 获取table数据方法
    const getClassiftListMethod = (reviewRequest) => {
        desingerQueryList(reviewRequest).then((res) => {
            if (res?.error?.errorCode == 0) {
                if (res?.data?.contents.length > 0) {
                    setTableList(res?.data?.contents)
                    setTotal(res?.data?.total)
                } else {
                    setTableList([])
                    setTotal(0)
                    message.error('暂无数据')
                }

            }
        }).finally(() => {
            setListLoading(false)
        })
    }
    // 获取一级分类下拉框数据
    const getFirstClassifyList = () => {
        designerClassifyList()
            .then((res) => {
                if (res?.error?.errorCode == 0) {
                    setFirstClassifyList(res?.data?.classifyList)
                    setStyleList(res?.data?.styleList)
                    setPropertyList(res?.data?.propertyList)
                    dispatch({ info: { ...state.info, classifyList: res?.data?.classifyList, styleList: res?.data?.styleList, propertyList: res?.data?.propertyList } });
                    getDataList(1)
                }
            })
    }
    // 一级分类change
    const handleChangeFirstClassify = value => {
        setfirstClassifyChoose(value);
        let secondClassifyList = firstClassifyList.filter(item => item.id == value)
        setSecondClassifyList(secondClassifyList[0].secondClassifies)//存储当前二级分类数据
        if (secondClassifyList[0].secondClassifies.length > 0) {
            setsecondClassifyChoose(secondClassifyList[0].secondClassifies[0].id)
        } else {
            setsecondClassifyChoose('')
            setThirdClassifyChoose('')
        }
    };
    // 二级分类change
    const handleChangeSecondClassify = value => {
        setsecondClassifyChoose(value);
        let thirdClassifyList = secondClassifyList.filter(item => item.id == value)
        setThirdClassifyList(thirdClassifyList[0].thirdClassifies)
        if (thirdClassifyList[0].thirdClassifies.length > 0) {
            setThirdClassifyChoose(thirdClassifyList[0].thirdClassifies[0].id)
        } else {
            setThirdClassifyChoose('')
        }
    };
    // 三级分类change
    const handleChangeThirdClassify = value => {
        setThirdClassifyChoose(value);
    };

    //  风格选中 
    const handleChangeStyle = value => {
        setStyleChoose(value)
    }
    //  擅长领域选中 
    const handleChangeField = value => {
        setPropertyId(value)
    }
    //  创建时间筛选 
    const handleChangeCreatedTime = (value, dateArr) => {
        setTimer(value)
        let timeArr = [...dateArr];
        timeArr[0] = timeArr[0].replace(/\//g, '-')
        timeArr[1] = timeArr[1].replace(/\//g, '-')
        setDateArr(timeArr)//替换 / 为 -  重新赋值
    }
    // 选择状态
    const handleChangeStatus = (value) => {
        console.log(value)
        setChoosestatus(value)
    }
    // 查询
    const searchList = () => {
        setPage(1)
        getDataList(1)
    }
    // 重置选项
    const resetData = () => {
        setDateArr([])
        setTimer(null)//重置时间区间
        setStyleChoose('')//重置状态下拉框
        setPropertyId('')//重置状态下拉框
        setDesingerSort(null);
        setfirstClassifyChoose('');
        setsecondClassifyChoose('');
        setThirdClassifyChoose('')
        setDesingerName('')
        setPropertyId('')
        setPage(1)
        setChoosestatus(2)
        state.success = true;
    }
    const newDesinger = () => {
        dispatch({
            isModalVisible: true,
            info: {
                ...state.info,
                isEditor: false,
                classifyList: firstClassifyList,
                headTitle: '新建设计师信息',
                caseClassifyDTOList: [],
                designMaster: null,
                propertyId: '',
                styleId: '',
            }
        });
    }
    // 处理重复数据数组转字符串方法
    const handleRepeatName = (arr) => {
        if (arr?.length > 0) {
            return arr.join('、')
        }
    }
    // 保存提交添加作品按钮时间
    const saveAddWork = () => {

    }
    // 选择单选框事件
    const radioOnChange = (e) => {
        console.log(e.target.value)
        setChooseRadioValue(e.target.value)
    }

    // 保存提交和一键采集
    const addWorkConfirm = async () => {
        let params = {
            caseIdList: [],
            designPropertyId: desingerId,
            spiderUrl: '',
            type: 1,
        }
        switch (chooseRadioValue) {
            case 1:
                if (publicNumId != '') {
                    params.spiderUrl = publicNumId
                    let res1 = await addBatch(params)
                    if (res1?.error?.errorCode == 0) {
                        message.success('提交成功')
                        setPublicNumId('')
                    } else {
                        message.warn(res1?.data)
                    }
                } else {
                    message.warn('公众号id不能为空')
                }

                return;
            case 2:
                params.spiderUrl = caseLink
                params.type = 0
                let res2 = await addBatch(params)
                if (res2?.error?.errorCode == 0) {
                    message.success('提交成功')
                    setCaseLink('')
                } else {
                    message.warn(res2?.data)
                }
                return;
            case 3:
                let array = Array.from(new Set(caseIds.split('\n')));
                params.caseIdList = array
                params.spiderUrl = ''
                params.type = 2
                let res3 = await addBatch(params)
                if (res3?.error?.errorCode == 0) {
                    message.success('维护成功')
                    setCaseIds('')
                } else {
                    message.warn(res3?.data)
                }
                return;
            default:
                return
        }
    }
    // 一键采集事件
    const oneCollect = (link) => {

    }
    // 输入的案例id集合
    const handleChanges = (e) => {
        setCaseIds(e.target.value)
    }
    // 文件错误判断
    const beforeUpload = (file) => {
        console.log(file);
        const name = file.name.split(".");
        if (name[name.length - 1] === "xlsx" || name[name.length - 1] === "xls") {
            setShowSpinLoading(true)
            return true;
        }
        message.error("请上传 excel 文件！");
        return false;
    };
    // 导入成功回调
    const onUploadChange = (res) => {
        // 导入成功前展示loading
        if (res?.error?.errorCode == 0) {
            setShowSpinLoading(false)
            setUplodaData(res?.data)
            setShowImportModal(true)
        } else {
            return message.error(res?.error?.errorMsg ?? "发生错误");
        }
    }
    return (
        <>
            <div className="classifyManage">
                <div className="topForm">
                    <h2>
                        设计师频道页管理
                        <div style={{ float: 'right' }}>
                            <Button type="primary" onClick={() => {
                                window.open('https://hr7ljf0dhp.feishu.cn/sheets/shtcn8oFdVKFqlxMgog670xP9gf')
                            }} disabled={showSpinLoading}>批量导入模板下载</Button>
                            <Upload
                                action={`${news_host}/designer/import`}
                                method="post"
                                beforeUpload={beforeUpload}
                                fileList={[]}
                                onSuccess={onUploadChange}
                                accept={'.xls, .xlsx'}
                            >
                                <Button style={{ marginLeft: '20px' }} type="primary" disabled={showSpinLoading}>批量导入</Button>
                            </Upload>

                        </div>
                    </h2>

                    <div className="myForm">
                        <div>
                            <span className="select_label">设计师名称：</span>
                            <Input type={Number} style={{ width: 155 }} placeholder="请输入设计师名称" value={desingerName} disabled={showSpinLoading} onChange={(e) => {
                                setDesingerName(e.target.value)
                            }} />
                        </div>
                        <div>
                            <span className="select_label">一级分类：</span>
                            <Select value={firstClassifyChoose} style={{ width: 170 }} onChange={handleChangeFirstClassify} disabled={showSpinLoading}>
                                {
                                    firstClassifyList.length > 0 ? firstClassifyList.map((item, index) => {
                                        return (
                                            <Option value={item.id} key={index}>{item.name}</Option>
                                        )
                                    }) : ''
                                }
                            </Select>
                        </div>
                        <div>
                            <span className="select_label">二级分类：</span>
                            <Select value={secondClassifyChoose} style={{ width: 120 }} disabled={showSpinLoading} onChange={handleChangeSecondClassify}>
                                {
                                    secondClassifyList.length > 0 ? secondClassifyList.map((item, index) => {
                                        return (
                                            <Option value={item.id} key={index}>{item.name}</Option>
                                        )
                                    }) : ''
                                }
                            </Select>
                        </div>
                        <div>
                            <span className="select_label">三级分类：</span>
                            <Select value={thirdClassifyChoose} style={{ width: 120 }} disabled={showSpinLoading} onChange={handleChangeThirdClassify}>
                                {
                                    thirdClassifyList.length > 0 ? thirdClassifyList.map((item, index) => {
                                        return (
                                            <Option value={item.id} key={index}>{item.name}</Option>
                                        )
                                    }) : ''
                                }
                            </Select>
                        </div>
                        <div>
                            <span className="select_label">设计风格：</span>
                            <Select value={styleChoose} style={{ width: 120 }} disabled={showSpinLoading} onChange={handleChangeStyle}>
                                {
                                    styleList.length > 0 ? styleList.map((item, index) => {
                                        return (
                                            <Option value={item.id} key={index}>{item.styleValue}</Option>
                                        )
                                    }) : ''
                                }
                            </Select>
                        </div>
                        <div>
                            <span className="select_label">擅长领域：</span>
                            <Select value={propertyId} disabled={showSpinLoading} style={{ width: 120 }} onChange={handleChangeField}>
                                {/* <Option value={'666'} key={'666'}>全部</Option> */}
                                {
                                    propertyList.length > 0 ? propertyList.map((item, index) => {
                                        return (
                                            <Option value={item.id} key={index}>{item.name}</Option>
                                        )
                                    }) : ''
                                }
                            </Select>
                        </div>
                        <div>
                            <span className="select_label">设计师序号：</span>
                            <Input type={Number} style={{ width: 155 }} placeholder="请输入设计师序号：" value={desingerSort} disabled={showSpinLoading} onChange={(e) => {
                                setDesingerSort(e.target.value)
                            }} />
                        </div>
                        <div>
                            <span className="select_label">创建时间：</span>
                            <RangePicker
                                value={timer}
                                showTime={{ format: 'HH:mm:ss' }}
                                format="YYYY/MM/DD HH:mm:ss"
                                onChange={handleChangeCreatedTime}
                                disabled={showSpinLoading}
                            />
                        </div>
                        <div>
                            <span className="select_label">状态：</span>
                            <Select value={choosestatus} style={{ width: 120 }} onChange={handleChangeStatus} disabled={showSpinLoading}>
                                {/* <Option value={'666'} key={'666'}>全部</Option> */}
                                {
                                    statusData.length > 0 ? statusData.map((item, index) => {
                                        return (
                                            <Option value={item.id} key={index}>{item.name}</Option>
                                        )
                                    }) : ''
                                }
                            </Select>
                        </div>
                        <div>
                            {/* <Button type="primary" onClick={search}>查询</Button> */}
                            <Button type="primary" onClick={searchList} disabled={showSpinLoading}>查询</Button>
                            <Button type="primary" onClick={resetData} disabled={showSpinLoading}>重置</Button>
                        </div>
                        <Button style={{ float: 'right' }} type="primary" onClick={newDesinger} disabled={showSpinLoading}>新建</Button>
                    </div>

                </div>
                <div className="bottomTable">
                    <Table
                        loading={listLoading}
                        columns={columns}
                        dataSource={tableList}
                        pagination={
                            {
                                total: total,
                                current: page,
                                onChange(page) {
                                    setPage(page)
                                    getDataList(page)
                                },
                                pageSize: pageSize
                            }
                        }
                    />
                </div>
                <Ctx.Provider value={{ state, dispatch }} >
                    <EditModal isModalVisible={state.isModalVisible} />
                </Ctx.Provider>

            </div >

            {showSpinLoading && <Spin className='spin' tip="数据导入中,请勿关闭当前页面" spinning={showSpinLoading}>
            </Spin>}
            <Modal title="" visible={showImportModal} footer='' keyboard onCancel={() => {
                setShowImportModal(false)
                getDataList(1);// 提示弹窗关闭刷新数据
                setPage(1)
            }}>
                <p>
                    <span>提交总数：</span>
                    <span>{uplodaData?.total}</span>
                </p>
                <p>
                    <span>导入成功：</span>
                    <span>{uplodaData?.successSize}</span>
                </p>
                <p>
                    <span>重复数据：</span>
                    <span>{uplodaData?.repeatNameList?.length}</span>
                    {
                        uplodaData?.repeatNameList?.length > 0 ? (
                            <span>{'(' + handleRepeatName(uplodaData?.repeatNameList) + ')'}</span>
                        ) : ""
                    }

                </p>
                <p>
                    <span>导入失败：</span>
                    <span>{uplodaData?.errorNameList?.length}</span>
                    {
                        uplodaData?.errorNameList?.length > 0 ? (
                            <span>{'(' + handleRepeatName(uplodaData?.errorNameList) + ')'}</span>
                        ) : ''
                    }

                </p>
            </Modal>
            <Modal wrapClassName='addWordModal' width={1000} height={600} title={'设计师作品添加：' + desingerAddName} visible={showAddWorkModal} footer={chooseRadioValue != 2 ? [
                <Button key="submit" type="primary" disabled={((publicNumId != '' && chooseRadioValue === 1) || (caseIds != '' && chooseRadioValue === 3)) ? false : true} onClick={() => addWorkConfirm('保存提交传入的信息')}>
                    保存提交
                </Button>
            ] : ''} onOk={saveAddWork} keyboard onCancel={() => {
                setShowAddWorkModal(false)
                setPublicNumId('')
                setCaseLink('')
                setCaseIds('')
                setChooseRadioValue(1)
            }}>
                <p>
                    <span className='leftTitle'>添加来源：</span>
                    <Radio.Group onChange={radioOnChange} value={chooseRadioValue}>
                        <Radio value={1}>公众号导入</Radio>
                        <Radio value={2}>链接抓取</Radio>
                        <Radio value={3}>案例id批量提交</Radio>
                    </Radio.Group>
                </p>
                {
                    chooseRadioValue == 1 ? (
                        <p>
                            <span className='leftTitle'>公众号id:</span>
                            <Input style={{ width: 155 }} placeholder="请输入公众号id" value={publicNumId} onChange={(e) => {
                                setPublicNumId(e.target.value)
                            }} />
                        </p>
                    ) : ""
                }
                {
                    chooseRadioValue == 2 ? (
                        <p>
                            <span className='leftTitle'>案例链接:</span>
                            <Input style={{ width: 355 }} placeholder="请输入案例链接" value={caseLink} onChange={(e) => {
                                setCaseLink(e.target.value)
                            }} />
                            <Button style={{ marginLeft: '20px' }} type="primary" disabled={caseLink?.length ? false : true} onClick={() => { addWorkConfirm() }}>一键采集</Button>
                        </p>
                    ) : ""
                }
                {
                    chooseRadioValue == 3 ? (
                        <p>
                            <span className='leftTitle'>案例ID:</span>
                            <Input.TextArea autoSize={{ minRows: 8, maxRows: 100000 }} allowClear={true}
                                placeholder={'使用说明:\r\n多个案例id请换行排列,最后一个案例id不要在换行\r\n示例:\r\n111\r\n222\r\n333\r\n'}
                                onChange={handleChanges} value={caseIds} />
                        </p>
                    ) : ""
                }
            </Modal>
        </>

    )
}

export default ClassifyManage;